module.exports = __webpack_public_path__ + "front/img/top.eb0d5536.jpg";